//
// UrlLink
//
// newWindow: will open a new independant window
// reload: will reload the page. reload=false lets the user navigate inside the
//   React app without reloading
//
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import SvgColorImg from '../SvgColorImg';

const UrlLink = function UrlLink(props) {
  const {
    className,
    href,
    text,
    newWindow,
    reload,
    disabled,
    imgSrc,
    noWordBreak = false,
  } = props;

  if (disabled) {
    return (
      <span
        className={classNames(
          'text-sm max-w-full',
          {
            'break-normal': noWordBreak,
            'break-words': !noWordBreak,
          },
          className,
        )}
      >
        {text || href}
      </span>
    );
  }

  if (reload) {
    return (
      <a
        target={(newWindow) ? '_blank' : undefined}
        rel={(newWindow) ? 'noopener noreferrer' : undefined}
        href={href}
        className={classNames(
          'text-sm max-w-full text-pxTxtLink underline',
          {
            'break-normal': noWordBreak,
            'break-words': !noWordBreak,
          },
          className,
        )}
      >
        {text || href}
      </a>
    );
  }

  return (
    <Link
      to={href}
      className={classNames(
        'text-sm max-w-full text-pxTxtLink underline',
        className,
        {
          'flex flex-row items-center gap-2': imgSrc,
          'break-normal': noWordBreak,
          'break-words': !noWordBreak,
        },
      )}
    >
      {(imgSrc)
        ? (
            <SvgColorImg
              src={imgSrc}
              description="."
              className="h-4 w-4 shrink-0 fill-pxTxtLink"
              imgColorAsCssFill
            />
          )
        : null}
      <span>{text || href}</span>
    </Link>
  );
};

UrlLink.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string.isRequired,
  text: PropTypes.node,
  newWindow: PropTypes.bool,
  reload: PropTypes.bool,
  disabled: PropTypes.bool,
  imgSrc: PropTypes.string,
  noWordBreak: PropTypes.bool,
};

export default UrlLink;
